/**
 * Created by emanuele on 23/05/2017.
 */
import React, {Component} from 'react';
import PrintButton from '../PrintButton'
import PdfButton from '../PdfButton'
import ReportSoggettiViewSwitcher from '../report/ReportSoggettiViewSwitcher'
import RubricaElencoCompleto from '../../pdf/RubricaElencoCompleto'
import RubricaElencoCompatto from '../../pdf/RubricaElencoCompatto'

class RubricaReportList extends Component {

    constructor(props) {
        super(props);
        this.pdfExport = this.pdfExport.bind(this);
        this.pdfCompattoExport = this.pdfCompattoExport.bind(this);
    }

    pdfExport(){
        let ce = new RubricaElencoCompleto();
        ce.setTitle("Elenco Soggetti - completo");
        ce.setFileName("report-soggetti-completo.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.props.items);
    }

    pdfCompattoExport(){
        let ce = new RubricaElencoCompatto();
        ce.setTitle("Elenco Soggetti - compatto");
        ce.setFileName("report-soggetti-compatto.pdf");
        ce.setFilterDescription(this.props.filterDescription);
        ce.createPdf(this.props.items);
    }

    render(){
        return (
            <div className="ui segments">
                <div className="ui secondary segment">
                    <div className="ui one column stackable grid">
                        <div className="row">
                            <div className="column">
                                <PrintButton />
                                <PdfButton title="PDF Completo" onClick={(ev) => (this.pdfExport())} />
                                <PdfButton title="PDF Compatto" onClick={(ev) => (this.pdfCompattoExport())} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ui segment">
                    <ReportSoggettiViewSwitcher {...this.props} />
                </div>
            </div>
        )
    }
}

export default RubricaReportList;


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaReportList.js
 **/